import { Card, CardBody, Text } from '@backstage/ui';

import styles from './TeamEmptyState.module.css';

interface TeamEmptyStateProps {
  team?: string;
}

export const TeamEmptyState = ({ team }: TeamEmptyStateProps) => (
  <Card className={styles.emptyState}>
    <CardBody>
      <Text as="h2" variant="title-small" className={styles.sectionTitle}>
        No scorecard results for this group
      </Text>
      {team ? (
        <Text as="p" color="secondary">
          Projects are linked to a team through a GitLab project topic. Add the
          topic <code>{team}</code> to the team's GitLab projects; they show up
          here after the next scorecard run.
        </Text>
      ) : (
        <Text as="p" color="secondary">
          Scorecards are shown for teams only. Projects are linked to a team
          through the GitLab project topic <code>team-&lt;name&gt;</code>.
        </Text>
      )}
    </CardBody>
  </Card>
);
